import React from 'react'
import Header from './Header'
import BasicExample from './Navbar'

function Home() {
  return (
    <div className='hero-sec'>
    
    <BasicExample />
    <Header />
    
    </div>
  )
}

export default Home